/***
 * 放一些和流程逻辑无关的处理
 * **/
import sdkTool from "If_AdTool/common/sdkTool";
// 获得真正数据
export function getRealNum(n, realEl,percent=true){
    let realValue = n;
    if (realEl){
        switch (typeof n) {
            case "function":
                realValue = n(realEl);
                break;
            case "string":
                if (percent && n.substr(n.length - 1, 1) == "%") {
                    let parentEl = realEl.parentNode || document.body;
                    realValue = parentEl.offsetWidth;
                }
                break;
        }
    }
    return realValue
}
// 获得域名
export function getCH() {
    let ch = "";
    if (sdkTool.isMobile()) {
        let urlobj = sdkTool.urlToObj(window.location.href);
        if (urlobj && urlobj.hasOwnProperty("ch")) {
            ch = urlobj.ch;
        }
    } else {
        var arr = window.location.href.match(/[&|#|\?]+(_.*?)(?=&|\s|\?|\||#|%|$)/);
        if (arr && arr.length > 1) {
            ch = arr[1];
        }
    }
    return ch;
}
// 获得额外数据
export function getExtend(){
    let extend = "";
    try {
        let urlobj = sdkTool.urlToObj(window.location.href);
        if (urlobj && urlobj.hasOwnProperty("iip")) {
            extend = "&iip=" + urlobj.iip;
        }
        if (urlobj && urlobj.hasOwnProperty("liveid")) {
            extend = "&liveid=" + urlobj.liveid;
        }
        if (typeof allData != 'undefined'){
            if (typeof allData.topic != 'undefined' && allData.topic != '') {
                extend += '&zt=' + allData.topic;
            } else {
                if (allData.hasOwnProperty("docData") && allData.docData.type == 'special' && allData.docData.hasOwnProperty("base62Id")) {
                    extend += '&zt=' + allData.docData.base62Id;
                }
            }
        }
        let metaObj = sdkTool.getMate();
        let closeObj = allData.safeLevel;
        let str = encodeURIComponent("商业合作专用")
        if(typeof closeObj != 'undefined' && closeObj ){
            extend += "&keywords=" + str;
        }else{
            if (metaObj.hasOwnProperty("keywords") && metaObj.keywords != "") {
                extend += "&keywords=" + encodeURIComponent(metaObj.keywords);
            }
        }
    } catch (e) {
        console.log(e);
    }
    return extend;
}

// 获得域名,不知道为啥会传 baidu.ua,和uc.ua,qq.ua.特别想删掉
export function getDomain() {
    let dm = location.hostname;
    if (sdkTool.isMobile()) {
        if (navigator.userAgent.match(/(baidubrowser|baiduboxapp)/i)) {
            dm = 'baidu.ua';
        }
        // uc target
        if (navigator.userAgent.match(/(ucbrowser|ucweb)/i)) {
            dm = 'uc.ua';
        }
        // qq target
        if (navigator.userAgent.match(/qqbrowser/i)) {
            dm = 'qq.ua';
        }
    }
    return dm;
}
export function isIndex() {
    let path = window.location.pathname;
    if (path == "/index.html" || path == "/index.html" || path == "/") {
        return true;
    } else {
        return false;
    }
}
//是否是模版，模版固定有3个参数 data,script,callback
export function isTpl (data) {
    return data.hasOwnProperty("data") && data.hasOwnProperty("script") && data.hasOwnProperty("callback")
}

/**
    * code 广告代码
    * encode 代码是否编码
    * 做了兼容旧模版处理
    * 读取模版中 <!--!和!-->或者<!--#和#-->之间代码
    * **/
export function setAdResCode(code, encode = true) {
    //兼容处理旧模版，规则
    let nCode = code;
    if (nCode=="null"||nCode.length<6){
        return ""
    }
    //如果模版已经编码，则解码，没有编码则不需要解码
    if (encode){
        try{
            //特殊处理
            nCode = decodeURIComponent(code.replace(/\+/g, "%20"))
        }catch(e){
        }
    }
    let start = -1, startStr = "", endStr = "";
    let end = -1;
    let pre = "#";
    if (nCode.indexOf("<!--!") != -1) {
        pre = "!";
    }
    startStr = "<!--" + pre;
    endStr = pre + "-->";
    start = nCode.indexOf(startStr) + startStr.length;
    end = nCode.indexOf(endStr);
    if (start != -1 && end != -1 && end >= start) {
        nCode = nCode.substring(start, end);
    };
    return nCode;
}

export function turnAdResCode(res) {
    if (typeof res=="object"){
        let turnRes = {};
        //兼容处理旧模版，规则
        for (let key in res) {
            let tRes = { ...res[key] };
            tRes.code = setAdResCode(tRes.code)
            turnRes[key] = tRes;
        }
        return turnRes;
    }else{
        return res;
    }
}


//是否是错误
export function checkErrCode(data) {
    return /^\{.*\}$/.test(data);
}